import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { FilledButtonComponent, OutlinedButtonComponent } from '@custom-components/general/button';
import { DialogShellComponent } from '@custom-components/overlay/dialog-shell/dialog-shell.component';

export interface RemoveInstallationGroupDialogData {
  /** Name of the installation group shown in the confirmation. */
  groupName: string;
}

@Component({
  selector: 'xemex-remove-installation-group-dialog',
  imports: [
    MatDialogModule,
    TranslateModule,
    FilledButtonComponent,
    OutlinedButtonComponent,
    DialogShellComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './remove-installation-group-dialog.component.html',
})
export class RemoveInstallationGroupDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<RemoveInstallationGroupDialogComponent>);
  readonly data = inject<RemoveInstallationGroupDialogData>(MAT_DIALOG_DATA);

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
